export function AccessDeniedPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold">Access pending</h1>
      <p className="mt-2 text-slate-700">
        You&apos;re signed in, but you don&apos;t yet have a Flow role assigned.
      </p>
      <p className="mt-2 text-slate-600">
        Flow roles are granted via Entra group membership
        (<code>MASFlow-Viewers</code>, <code>MASFlow-Scorers</code>,{' '}
        <code>MASFlow-Leaders</code>, <code>MASFlow-Admins</code>). Ask your administrator
        to add you to the appropriate group, then refresh this page.
      </p>
    </div>
  );
}
